import React, { useState, useEffect, ReactElement } from "react";

// modules
import { useSelector, shallowEqual } from "react-redux";

// Components

import VideoStream from "../../components/videoStream/videoStream";
import Image from "../../components/image/image.component";

// Styles
import "./event.component.scss";

// Images
import remoteLogoWhite from "../../assets/images/remote-meeting-logo-white.png";

// apis
import { fetchStreamInfoById } from "../../apis/firebase";

import { useTranslation } from "react-i18next";

import { Link, useParams } from "react-router-dom";

const EventPage = (): ReactElement => {
  const { t } = useTranslation();
  const { sessionId } = useParams<any>();

  const { track, generalSettings } = useSelector(
    ({ generalSettings, track }) => ({
      generalSettings,
      track,
    }),
    shallowEqual
  );

  const [sessionDetails, setSessionDetails] = useState<any>(null);

  const [streamDetail, setStreamDetail] = useState<any>(null);
  const [sessionName, setSessionName] = useState<string>(null);

  const [tabTypes, setTabTypes] = useState("");

  useEffect(() => {
    let _currentSession;
    if (!track.docId) return;
    if (!sessionId) {
      _currentSession = track.sessions.find(
        (d) => !!d.replay && !!d.replay.length
      );
    } else {
      _currentSession =
        track.sessions && track.sessions.find((d) => d.docId === sessionId);
    }
    if (_currentSession?.replay && _currentSession?.replay?.length) {
      const { replayId } = _currentSession.replay[0];
      if (replayId) fetchSteamDetails(replayId);
    }
    setTabTypes("playlist");
    setSessionDetails({ ..._currentSession });
  }, [track, sessionId]);

  useEffect(() => {
    if (!sessionDetails || !sessionDetails.docId) return;

    if (sessionDetails?.name) {
      setSessionName(sessionDetails?.name);
    }
  }, [sessionDetails?.docId]);

  const fetchSteamDetails = async (streamId) => {
    if (streamId) {
      const _detail = await fetchStreamInfoById(streamId);

      setStreamDetail({
        ..._detail,
        sessionId: sessionId || sessionDetails?.docId,
      });
    } else {
      setStreamDetail(null);
    }
  };

  const getTabTitle = () => {
    if (tabTypes === "playlist") {
      return t("LIVE_NAV_PLAYLIST");
    }
  };

  return (
    <>
      <div className="tm__event-wrapper d-flex flex-column h-100 w-100">
        <div className="d-flex flex-column flex-1 h-100 mh-0">
          <div className={`d-flex justify-content-center flex-1 h-100 mh-0`}>
            <div className="tm__event-player flex-1">
              {streamDetail && streamDetail.type && (
                <VideoStream
                  streamDetail={streamDetail}
                  stream_id={streamDetail?.settings?.videoId}
                />
              )}
            </div>

            <div
              className={`d-flex flex-column tm__event-polls
              ${tabTypes ? "tm__event-polls-active" : ""}
            `}>
              <div className="tm__event-polls-head d-flex align-items-center justify-content-between p-2">
                <label className="fw-bold text-capitalize">
                  {getTabTitle()}
                </label>

                <button
                  type="button"
                  onClick={() => {
                    setTabTypes("");
                  }}>
                  <i className="bi bi-x-lg"></i>
                </button>
              </div>
              <div
                className={`tm__event-polls-body flex-1
                ${tabTypes === "polls" ? "p-4" : ""}
              `}>
                {tabTypes && tabTypes === "playlist" && (
                  <div className="m-2">
                    {track?.sessions &&
                      track?.sessions.map((d) => (
                        <div
                          key={d?.docId}
                          className={`tm__polls tm__replay-playlist
                        ${
                          d?.docId === sessionDetails.docId
                            ? "tm__replay-playlist-active"
                            : d.replay && d.replay.length
                            ? ""
                            : "opacity-50"
                        }
                      `}>
                          {/* upcoming-playlist class for upcoming playlist */}
                          <div className="tm__polls-body d-flex">
                            <div className="d-flex flex-column w-100">
                              <div className="d-flex justify-content-between align-items-center lh-sm">
                                <label className="d-flex align-items-center fs-7 m-0 lh-sm text-primary">
                                  {d.name}
                                </label>
                                <div className="d-flex  align-items-end ms-3">
                                  {d.replay &&
                                    !!d.replay.length &&
                                    d.docId !== sessionDetails.docId && (
                                      <Link
                                        className="btn-icon btn-icon-primary btn-icon-small rounded-circle"
                                        to={`/replay/${d.docId}`}>
                                        <i className="bi bi-play-fill"></i>
                                      </Link>
                                    )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}

                    <div className="tm__polls-body"></div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="p-3 text-center text-white">
            <label className="fs-5">{sessionName}</label>
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-center justify-content-lg-between">
          <div className="tm__event-logos mw-15 d-none d-lg-block">
            <img src={remoteLogoWhite} alt="" className="h-100" />
          </div>
          <div className="tm__event-navbar-wrapper d-flex p-0">
            <nav id="tm__event-navbar">
              <ul className="d-flex align-items-center list-style-none m-0 p-0">
                {generalSettings?.micrositeEnabled && (
                  <li>
                    <Link
                      to="/"
                      className="d-flex flex-column align-items-center">
                      <i className="bi bi-house-fill"></i>
                      <label className="fs-8"> {t("LIVE_NAV_HOME")}</label>
                    </Link>
                  </li>
                )}

                <li>
                  <button
                    className={`d-flex flex-column align-items-center
                    ${tabTypes === "playlist" ? "active" : ""}
                  `}
                    onClick={() => {
                      setTabTypes(tabTypes === "playlist" ? "" : "playlist");
                    }}>
                    <i className="bi bi-collection-play-fill"></i>
                    <label className="fs-8">{t("LIVE_NAV_PLAYLIST")}</label>
                  </button>
                </li>
              </ul>
            </nav>
          </div>
          <div className="tm__event-logos mw-15 text-end d-none d-lg-block">
            <Image
              title={generalSettings?.clientName}
              path={generalSettings?.clientLogo}
              className="h-100"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default EventPage;
